import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'
import Flex from 'styled-flex-component'

import BrandFansContentUnsupportedScreenHandler from '@components/BrandFans/Content/UnsupportedScreenHandler'
import { NoticeEmpty } from '@components/UI/Notice'
import { withRememberScrollPosition } from '@hocs'
import { IApplicationState } from '@store'
import {
  fetchBrandFanGroups,
  selectBrandFanGroupDescription,
  selectBrandFanGroupIds,
  selectBrandFanGroupMemberCount,
  selectBrandFanGroupName,
} from '@store/brandFans'
import { selectCreateCampaignLink } from '@store/campaigns'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'
import { isEmpty } from '@utils'
import BrandFansGroupMemberList from '../Member/List'
import { Root } from './Details.styled'
import BrandFansGroupDetailsHeader from './Header'
import BrandFansGroupDetailsSort from './Sort'

const BrandFanGroupMembersNoticeEmpty: React.FC = () => (
  <NoticeEmpty
    topOuterSpacing={4}
    title={
      <Container topOuterSpacing={2} maxWidth={16.875}>
        <Text italic color={Theme.grey800Color} light customFontSize={1}>
          <FormattedMessage id="brandFans.memberList.empty" />
        </Text>
      </Container>
    }
    alt="empty-members-list"
  />
)

const BrandFansGroupDetails: React.FC = () => {
  const dispatch = useDispatch()
  const match = useRouteMatch<{ brandFansGroupId: string }>()
  const groupId = (
    match.params.brandFansGroupId ? parseInt(match.params.brandFansGroupId, 10) : undefined
  ) as number
  const memberCount = useSelector((state: IApplicationState) =>
    selectBrandFanGroupMemberCount(state, groupId),
  )
  const groupName = useSelector((state: IApplicationState) =>
    selectBrandFanGroupName(state, groupId),
  )
  const groupDescription = useSelector(
    (state: IApplicationState) => selectBrandFanGroupDescription(state, groupId) ?? '',
  )
  const groupsFetched = useSelector(
    (state: IApplicationState) => !isEmpty(selectBrandFanGroupIds(state)),
  )
  const hasCreateCampaignLink = useSelector((state: IApplicationState) =>
    Boolean(selectCreateCampaignLink(state)),
  )

  React.useEffect(() => {
    if (!groupsFetched) {
      dispatch(fetchBrandFanGroups())
    }
  }, [])

  if (!groupsFetched) {
    return null
  }
  return (
    <Root>
      <BrandFansContentUnsupportedScreenHandler>
        <BrandFansGroupDetailsHeader
          groupId={groupId}
          count={memberCount}
          name={groupName}
          description={groupDescription}
          showCreateCampaignButton={hasCreateCampaignLink}
        />
        {memberCount > 0 ? (
          <React.Fragment>
            <Flex justifyEnd>
              <BrandFansGroupDetailsSort groupId={groupId} />
            </Flex>
            <BrandFansGroupMemberList groupId={groupId} />
          </React.Fragment>
        ) : (
          <BrandFanGroupMembersNoticeEmpty />
        )}
      </BrandFansContentUnsupportedScreenHandler>
    </Root>
  )
}

export { BrandFansGroupDetails }
export default withRememberScrollPosition(BrandFansGroupDetails)
